import { ALIGN_START } from '../pm-plugins/utils/alignment';
var centerAlignStyle = {
  display: 'flex',
  justifyContent: 'center'
};
var leftAlignStyle = {
  display: 'flex',
  justifyContent: 'flex-start'
};
export var getAlignmentStyle = function getAlignmentStyle(alignment) {
  return alignment === ALIGN_START ? leftAlignStyle : centerAlignStyle;
};